import { render } from "./ManageCutiKaryawan.vue?vue&type=template&id=9970b8de&scoped=true"
import script from "./ManageCutiKaryawan.vue?vue&type=script&lang=js"
export * from "./ManageCutiKaryawan.vue?vue&type=script&lang=js"

import "./ManageCutiKaryawan.vue?vue&type=style&index=0&id=9970b8de&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9970b8de"]])

export default __exports__